<!--契約照会 一覧-->
<template>
  <div style="border: 0px solid red; height:100%">
    <el-container style="padding: 0px; width: 100%;height:100%;">
      <!--テーブル-->
      <el-main style="padding: 0px 0px 0px 0px; width: 100%;height: 100%;">
        <!--検索-->
        <div class="search-module-k">
          <el-row style="padding-top:5px;padding-left:5px" :gutter="20">
            <!--年-->
            <el-col :span="8">
              <el-date-picker class="c0001-year-select" format="yyyy" value-format="yyyy" v-model="targetYear" type="year" size="mini" @change="selectYear()" :clearable="false" :editable="false"></el-date-picker>
            </el-col>
            <!--前年 按钮-->
            <el-col :span="6" style="padding-left: 10px; padding-right: 10px;">
              <div>
                <el-button type="primary" class="c0001-css-button c0001-css-btn" @click="handleClick1" v-loading.fullscreen.lock="fullscreenLoading" size="mini">{{$t('MODULE.C0001_LBL_MSG1')}}</el-button>
              </div>
            </el-col>
            <!--翌年 按钮-->
            <el-col :span="6" style="padding-left: 10px; padding-right: 10px;">
              <div>
                <el-button type="primary" class="c0001-css-button c0001-css-btn" @click="handleClick2" v-loading.fullscreen.lock="fullscreenLoading" size="mini">{{$t('MODULE.C0001_LBL_MSG2')}}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div style="padding-top: 3px;padding-bottom: 5px;"></div>
        <el-table style=" border: 0px solid #AAAAAA" :header-cell-style="c0001HeaderStyle" :cell-style="c0001IsCellStyle" :header-row-class-name="c0001HeaderClass" :cell-class-name="c0001IsCellClass" 
          :data="list" border @row-click="c0001RowOnClick" size="mini">
          <!--显示列-->
          <!--月-->
          <el-table-column fixed="left" :label="$t('MODULE.C0001_LBL_COLUMN1')" min-width="30px" width="" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.issueDateMonth}}</div>
            </template>
          </el-table-column>
          <!--種類-->
          <el-table-column fixed="left" :label="$t('MODULE.C0001_LBL_COLUMN2')" min-width="" width="" align="center">
            <template slot-scope="scope">
              {{scope.row.documentName}}
            </template>
          </el-table-column>
          <!--同意日時-->
          <el-table-column fixed="left" :label="$t('MODULE.C0001_LBL_COLUMN3')" min-width="70px" width="" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.consentDate}}</div>
            </template>
          </el-table-column>
          <!-- レコード番号-->
          <el-table-column v-if="false">
            <template slot-scope="scope">
              <div>{{scope.row.recNo}}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import * as amsApi from "../api/c_0001"
import locale from "element-ui/lib/locale/lang/ja"
import Vue from "vue"
import ElementUI from "element-ui"
import css from "@/statics/css"
let url = require('@/../config/sysConfig')
Vue.use(ElementUI, { locale })
export default {
  mixins: [css],
  data() {
    return {
      userInfo: [],
      listLoading: false,
      fullscreenLoading: false,
      targetYear: '',
      list: [],
    };
  },
  created() {
    // 初期化
    this.init_query()
  },
  methods: {
    // 初期化
    init_query() {
      
      if (!(JSON.stringify(this.$route.query) == "{}")) {
        //详细画面返回的检索条件
        this.targetYear = JSON.parse(localStorage.getItem('C0001search_condition'));
      } else {
        //システム年度
        var dt = new Date();
        this.targetYear = dt.getFullYear().toString();
      }

      // 検索
      this.query(this.targetYear);
    },
    // 検索
    query(paramYear) {
      
      localStorage.setItem("C0001search_condition", JSON.stringify(paramYear));

      var params = {
        "year" : paramYear
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
      setTimeout(() => {
        loading.close()
      }, 2000)
      //検索処理
      amsApi.c_0001(params).then(res => {
        //API数据格式化整型
        this.list = this.formatDataFromApiForList(res.items.contractStatusSet)
        if (res.code === 300) {
          this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          loading.close()
          return
        }
        loading.close()
      }).catch((err) => {
        //关闭loading
        loading.close()
      });
    },
    selectYear() {
      // 検索
      this.query(this.targetYear);
    },
    //点击后失去焦点(用于按钮还原)/前年
    handleClick1(e) {
      let target = e.target;
      target.blur();
      let targetYearTemp = parseInt(this.targetYear) - 1;
      this.targetYear = String(targetYearTemp);
      // 検索
      this.query(this.targetYear);
    },
    //点击后失去焦点(用于按钮还原)/翌年
    handleClick2(e) {
      let target = e.target;
      target.blur();
      let targetYearTemp = parseInt(this.targetYear) + 1;
      this.targetYear = String(targetYearTemp);
      // 検索
      this.query(this.targetYear);
    },
    // ログアウト処理
    log_out() {
      this.$message.closeAll()
      var vm = this
      vm.$router.push({ path: "/login" })
    },
    // 戻る処理
    back_click() {
      var vm = this
      vm.$router.push({ path: url.routerUrl_Menu })
    },
    // TABLEHeader样式
    c0001HeaderStyle({ row, column, rowIndex, columnIndex }) {
      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:15px;text-align:center '
    },
    // TABLE单元格样式
    c0001IsCellStyle({ row, colum, rowIndex, columnIndex }) {
      if (columnIndex == 3) {
        return 'text-align:left;fontSize:13px'
      } else {
        return 'text-align:center;fontSize:13px'
      }
    },
    // 单击行事件
    c0001RowOnClick(thisRowDate, column, cell, event) {
      //発行日
      localStorage.setItem('obj', JSON.stringify(thisRowDate))
      localStorage.setItem(url.routerUrl_C0002, JSON.stringify(true))
      this.$router.push({ path: url.routerUrl_C0002 })
    },
    c0001HeaderClass({ row, rowIndex }) {
      return 'c0001HeaderClass'
    },
    c0001IsCellClass({ row, rowIndex }) {
      return 'c0001IsCellClass'
    },
    //Loading加载
    openFullScreen() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return loading;
    },
    closeFullScreen(loading) {
      loading.close();
    },
    //API数据格式化整型
    formatDataFromApiForList(contractStatusSet) {
      for (var item of contractStatusSet) {
        if (item.issueDate != null && item.issueDate != '') {
          var issueDateArry = item.issueDate.split('/');
          if (issueDateArry.length == 1) {
            //item.issueDateMonth = item.issueDate.substr(4,2) + this.$t('MODULE.C0001_LBL_COLUMN1');
            item.issueDateMonth = item.issueDate.substr(4,2) + '/' + item.issueDate.substr(6,2);
          } else {
            //item.issueDateMonth = issueDateArry[1] + this.$t('MODULE.C0001_LBL_COLUMN1');
            item.issueDateMonth = issueDateArry[1] + '/' + issueDateArry[2];
          }
        }
        if (item.consentDate != null && item.consentDate != '') {
          item.consentDate = item.consentDate.substr(0,16);
        }
      }
      return contractStatusSet;
    }
  },
}

</script>
<style scope>
/*表格单元格样式*/
.c0001IsCellClass .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
/*表格header单元格样式*/
.c0001HeaderClass .cell {
  white-space: pre-line;
}
/*ボタン*/
.c0001-css-button {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  color: #ffffff;
  width: 100%;
  font-size: 13px;
}
/*按钮经过样式*/
.c0001-css-btn:hover {
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
  color: #ffffff;
}
/*按钮激活和焦点样式*/
.c0001-css-btn:active,
.c0001-css-btn:focus {
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
  color: #ffffff;
}
/*按钮非活性和焦点样式*/
.c0001-css-btn.is-disabled,
.c0001-css-btn.is-disabled:focus,
.c0001-css-btn.is-disabled:hover {
  background-image: linear-gradient(#5bd3ff, #5bd3ff);
  color: #ffffff;
}
/*日期选择样式*/
.c0001-year-select .el-input__inner {
  width: 100px;
}
.c0001-year-select.el-date-editor.el-input {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/module/page/c_0001.vue